import {useNavigate, useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import * as React from "react";
import {useEffect, useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import ReferralForm from "./ReferralForm";
import referrals from "../../models/referrals";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function ReferralEdit() {
    const [searchParams] = useSearchParams();
    const [referralData, setReferralData] = useState(null)
    const [fields, setFields] = useState({})
    const [errors, setErrors] = useState({});
    const {setShowLoader} = useRootHook();
    const navigate = useNavigate()

    useEffect(() => {
        setShowLoader(true)
        const id = searchParams.get('id')
        if (!id) {
            setShowLoader(false)
            navigate('/referrals')
            return
        }
        referrals.get(parseInt(id))
            .then((data) => {
                setShowLoader(false)
                if (data) {
                    setReferralData(data)
                    setFields({
                        id: data.id,
                        username: data.username,
                        password: '',
                        name: data.name,
                        enabled: data.enabled,
                        merchants: data.merchants || []
                    })
                }
            }).catch(() => setShowLoader(false))

    }, [])

    const handleChange = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            newFields[name] = value;

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        typeof referrals.fieldValidator[name] === 'function'
        && referrals.fieldValidator[name](newFields, newErrors)

        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = referrals.methodValidator.edit(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        referrals.edit(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/referrals')
            }).catch(() => setShowLoader(false))
    }

    if (!referralData) return null

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="Edit referral"
                breadcrumbs={[['Dashboard', '/'], ['Referrals', '/referrals'], ['Edit', `/referrals/edit?id=${referralData.id}`]]}
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <ReferralForm fields={fields} errors={errors} handleChange={handleChange}
                              handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}

